const EMPTY_LABELS: Map<string, string> = new Map()

// Each markup is labelled with its Workflow's code.
export function markupLabelsFor(
  workflows: Map<string, { code?: string }> | null | undefined,
): Map<string, string> {
  if (!workflows) return EMPTY_LABELS
  const labels = new Map<string, string>()
  workflows.forEach((permit, id) => labels.set(id, permit.code ?? ''))
  return labels
}
